import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
	marginText:{
		margin: '15px 50px',
	}
}))